import {
  SecurityFormDefinition,
  SecuritySectionDefinition,
  toQuestionTitle
} from '../models/form-definition';
import { SITE_SECURITY_QUESTION_META } from './site-security.meta';

function section(
  key: string,
  title: string,
  introKey: string,
  questionKeys: string[]
): SecuritySectionDefinition {
  return {
    key,
    title,
    introKey,
    questions: questionKeys.map((questionKey) => ({
      key: questionKey,
      title: SITE_SECURITY_QUESTION_META[questionKey]?.prompt ?? toQuestionTitle(questionKey)
    }))
  };
}

export const SITE_SECURITY_FORM: SecurityFormDefinition = {
  key: 'site-security',
  title: 'AL Site Security',
  formType: 'Forms_Authenticated_General',
  sections: [
    section('security-management', 'Security Management', 'security_management_intro', [
      'security',
      'threat_assessment',
      'eop',
      'eop_faculty_training',
      'eop_student_training',
      'eop_security_exercise',
      'mass_notifications',
      'coordinate_first_responders',
      'security_information_staff',
      'suspicious_packages',
      'searches',
      'external_seurity_eop'
    ]),
    section('security-force', 'Security Force', 'security_force_intro', [
      'security_force',
      'training_provided',
      'security-inspections',
      'security_force_armed',
      'security_force_panic',
      'command_post',
      'monitor_vulnerablity',
      'share_external_agencies'
    ]),
    section('entry-control', 'Entry Control', 'entry_control', [
      'exterior_doors',
      'classroom_doors',
      'locks',
      'double_doors',
      'id_cards_staff',
      'id_cards_students',
      'access_after_school',
      'control_visitor_access',
      'student_items_inspected',
      'vistor_bags_inspected',
      'magnetometers_screen'
    ]),
    section('fencing-and-gates', 'Fencing And Gates', 'fencing_and_gates_intro', [
      'fencing',
      'fence_height',
      'fence_material',
      'fence_purpose',
      'gates',
      'monitoring_vehicles'
    ]),
    section('parking-and-barriers', 'Parking And Barriers', 'parking_and_barriers_intro', [
      'parked_vehicles',
      'vehicular_control',
      'high_speed_avenues',
      'minimum_standoff_distance'
    ]),
    section('building-envelope', 'Building Envelope', 'building_envelope_intro', [
      'interior_doors',
      'exterior_windows',
      'utilities',
      'ceilings',
      'hidden_areas',
      'building_objects',
      'fire_alarm_pull_stations'
    ]),
    section('ccv-vss', 'CCV VSS', 'ccv_vss_intro', [
      'camera_system',
      'camera_type',
      'system_monitored',
      'recorded_and_reviewed',
      'overall_condition'
    ])
  ]
};
